import {
  StorefrontCardView,
  StorefrontSearchView,
  StorefrontView,
} from '@zola/svc-marketplace-ts-types';

import { getZolaTopPicksSearches } from '~/libs/universal/vendorSearch';
import {
  VendorSearchRequest,
  VendorSearchRequestType,
  ZolaTopPickCategory,
} from '~/pages/couples/explore/components/SearchResults/types/types';
import type { CouplesStorefrontDetails } from '~/types/storefrontDetails';
import ApiService from '~/util/apiService';

export const getStorefront = (slug: string) => {
  return ApiService.get<StorefrontView>(`/web-marketplace-api/v1/storefront/by-slug/${slug}`);
};

export const getStorefrontByUuid = (uuid: string) => {
  return ApiService.get<StorefrontView>(`/web-marketplace-api/v1/storefront/by-uuid/${uuid}`);
};

export const getStorefrontDetails = (slug: string) => {
  return ApiService.get<CouplesStorefrontDetails>(
    `/web-marketplace-api/v1/storefront/with-details/${slug}`
  );
};

export const fetchStorefrontSearchResults = (
  search: VendorSearchRequestType
): Promise<StorefrontSearchView> => {
  return ApiService.post<StorefrontSearchView, VendorSearchRequestType>(
    '/web-marketplace-api/v4/storefront/search',
    search
  );
};

export const fetchZolaTopPicksResults = (
  search: VendorSearchRequest
): Promise<{ category: ZolaTopPickCategory; vendors: StorefrontCardView[] }[]> => {
  const requests = getZolaTopPicksSearches(search);

  return Promise.all(
    requests.map(({ category, searchRequest }) =>
      fetchStorefrontSearchResults(searchRequest).then((response) => ({
        category,
        vendors: response.entities,
      }))
    )
  );
};
